import React from 'react';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

import '../forms.css';
import './image.css';
import { systemText } from '../../../helpers/string';
import FormLabel from '../formLabel';

export class ImageEdit extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			uploaded: false,
			initialValue: props.value,
			preview: '',
			localSrc: '',
			zoom: 100,
			dragging: false,
			x: 0,
			y: 0,
			ix: 0,
			iy: 0,
			ox: 0,
			oy: 0,
			minZoom: 100,
			height: null,
			width: null,
			uploadError: null,
		};

		this.zoomIn = this.zoomIn.bind(this);
		this.zoomOut = this.zoomOut.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.remove = this.remove.bind(this);
		this.reset = this.reset.bind(this);
		this.onStart = this.onStart.bind(this);
		this.onDragDrop = this.onDragDrop.bind(this);
		this.onStop = this.onStop.bind(this);
		this.updateMetaData = this.updateMetaData.bind(this);
	}

	componentWillReceiveProps(newProps) {
		if (newProps.value !== this.props.value) {
			this.setState({ initialValue: newProps.value });
		}
	}

	updateMetaData() {
		const { x, y, zoom } = this.state;
		const { folder } = this.props;
		this.props.onMetaChange &&
			this.props.onMetaChange({
				x,
				y,
				zoom,
				fullX: 150 * (this.props.ratio || 1.5),
				fullY: 150,
				folder,
			});
	}

	reset() {
		const { minZoom } = this.state;
		this.setState(
			{
				x: 0,
				y: 0,
				ix: 0,
				iy: 0,
				ox: 0,
				oy: 0,
				zoom: minZoom ? minZoom : 100,
				dragging: false,
			},
			() => this.updateMetaData(),
		);
	}

	zoomOut() {
		const { zoom, minZoom } = this.state;
		const newZoom = zoom - 10 < minZoom ? minZoom : zoom - 10;
		this.setState({ zoom: newZoom }, () => this.updateMetaData());
	}

	zoomIn() {
		const { zoom } = this.state;
		this.setState({ zoom: zoom + 10 }, () => this.updateMetaData());
	}

	componentWillMount() {
		const { folder, value } = this.props;
		if (value && this.props.addImage) {
			this.props.addImage(folder, value);
		}
	}

	reject() {
		this.setState({
			uploadError: systemText('Admin/Forms/Image/Error'),
		});
	}

	remove() {
		if (typeof this.props.onChange === 'function') {
			this.props.onChange('');
		}

		this.setState(
			{
				uploaded: false,
				initialValue: '',
				zoom: 100,
				x: 0,
				y: 0,
				ix: 0,
				iy: 0,
				ox: 0,
				oy: 0,
			},
			() => this.updateMetaData(),
		);
	}

	onStart(e) {
		this.setState({
			ix: e.clientX ? e.clientX : e.touches[0].clientX,
			iy: e.clientY ? e.clientY : e.touches[0].clientY,
			dragging: true,
		});
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	onStop() {
		const { x, y } = this.state;
		this.setState({ dragging: false, ox: x, oy: y }, () => this.updateMetaData());
	}

	onDragDrop(e) {
		const { ix, iy, ox, oy, dragging, zoom, height, width } = this.state;
		if (dragging) {
			const clientX = e.clientX ? e.clientX : e.touches[0].clientX;
			const clientY = e.clientY ? e.clientY : e.touches[0].clientY;
			const webY = 150;
			const webX = webY * (1 + ratio / 100);
			const ratio = height && width && width > 0 ? height / width : 1;
			const yLimit = (webX * ratio * zoom) / 100;
			const xLimit = (webX * zoom) / 100;
			let x = clientX - ix + ox;
			x = x < 0 ? x : 0;
			x = webX - x > xLimit ? webX - xLimit : x;
			let y = clientY - iy + oy;
			y = y < 0 ? y : 0;
			y = webY - y > yLimit ? webY - yLimit : y;
			this.setState({ x, y });
		}
	}

	onDrop(files) {
		const localRatio = this.props.ratio || 1.5;
		if (files && files.length > 0) {
			if (files[0].size < this.props.config.MAX_ATTACHMENT_SIZE) {
				if (typeof this.props.onChange === 'function') {
					this.props.onChange(files[0]);
				}

				let reader = new FileReader();
				reader.onload = e => {
					this.setState({ localSrc: e.target.result });

					let newImage = new Image();
					newImage.src = e.target.result;
					const that = this;
					newImage.onload = function () {
						that.setState({ height: this.height, width: this.width });
						// access image size here
						if (this.width > this.height) {
							// sort zoom and put a min zoom option in here
							const yTrue = 150;
							const xTrue = yTrue * localRatio;
							const ratioX = xTrue / this.width;
							const ratioY = yTrue / this.height;
							if (ratioX < ratioY) {
								const zoom = Math.ceil((ratioY / ratioX) * 100);
								that.setState({ zoom, minZoom: zoom }, () => that.updateMetaData());
							}
						}
					};
				};

				reader.readAsDataURL(files[0]);

				this.setState({ uploaded: true, uploadError: null });
			} else {
				this.setState({ uploaded: false, uploadError: systemText('Admin/Forms/Image/TooLarge') });
			}
		} else {
			this.setState({
				uploaded: false,
				uploadError: systemText('Admin/Forms/Image/Error'),
			});
		}
	}

	render() {
		const { label, error, warning, help, id, folder, images, value, readonly, showFormHelp, ...rest } = this.props;
		const { uploaded, initialValue, zoom, minZoom, x, y, uploadError } = this.state;

		const ratio = Math.floor((1 / (this.props.ratio || 1.5)) * 100);
		const cropMode = initialValue || uploaded;
		let src = this.state.localSrc;
		if (!src && value && images && images.length > 0) {
			const potentials = images.filter(i => i.file === value && i.folder === folder);
			if (potentials.length > 0) {
				src = potentials[0].src;
			}
		}

		const style = {
			width: `${zoom}%`,
			left: `${x}px`,
			top: `${y}px`,
		};

		return (
			<div
				data-testid={rest['data-testid']}
				key={id}
				id={id}
				className={`admin-image form-group ${error ? 'has-error' : warning ? 'has-warning' : ''}`}
			>
				<FormLabel {...this.props} htmlFor="file-upload-dropzone-image" />
				<div className="row">
					{!cropMode ? (
						<div className="col-md-12">
							<div className={`dropzone-container dropzone-container-${ratio}`}>
								<Dropzone
									id="file-upload-dropzone-image"
									disabled={readonly}
									onDrop={files => this.onDrop(files)}
									multiple={false}
									accept={'.jpeg,.jpg,.png'}
									onDropRejected={this.reject}
									className="dropzone"
									activeClassName="active-dropzone"
								/>
								<div className="dropzone-help">
									{uploadError && (
										<span className="uploaded-files-error mb10 flex">
											<i className="fa fa-warning text-red mr10" />
											<span>{uploadError}</span>
										</span>
									)}
									{!uploadError && (
										<div className="hidden-xs">
											{systemText('Admin/Forms/Image/Help')}
											{readonly && (
												<p className="mt10">[{systemText('Admin/Forms/Image/Readonly')}]</p>
											)}
										</div>
									)}
									{uploadError && (
										<div className="hidden visible-xs">
											<i className="fa fa-warning" />
										</div>
									)}
									{!uploadError && (
										<div className="hidden visible-xs">
											<i className="fa fa-photo" />
										</div>
									)}
								</div>
							</div>
						</div>
					) : (
						<div className="col-md-12 flex">
							<div
								className={`preview-holder-${ratio}`}
								onMouseOut={!readonly && this.onStop}
								style={this.props.background ? { backgroundColor: this.props.background } : null}
							>
								<img
									draggable={!readonly}
									onDragStart={!readonly && this.onStart}
									onTouchStart={!readonly && this.onStart}
									onMouseMove={!readonly && this.onDragDrop}
									onTouchMove={!readonly && this.onDragDrop}
									onDragEnd={!readonly && this.onStop}
									onMouseUp={!readonly && this.onStop}
									onTouchEnd={!readonly && this.onStop}
									style={style}
									folder={folder}
									src={src}
									alt=""
								/>
							</div>
							{!readonly && (
								<div className="ml20">
									<div className="mb10 text-center">
										<button
											className="btn btn-default mr10"
											title="Zoom In"
											onClick={() => this.zoomIn()}
										>
											<i className="fa fa-plus" />
										</button>
										<button
											className="btn btn-default"
											title="Zoom Out"
											disabled={zoom === minZoom}
											onClick={() => this.zoomOut()}
										>
											<i className="fa fa-minus" />
										</button>
									</div>
									<div className="mb10 text-center">
										<button
											className="btn btn-default"
											disabled={zoom === minZoom && x === 0 && y === 0}
											onClick={() => this.reset()}
										>
											<i className="fa fa-reset" /> {systemText('Admin/Forms/Image/Buttons/Reset')}
										</button>
									</div>
									<div>
										<button className="btn btn-default" onClick={() => this.remove()}>
											<i className="fa fa-trash" /> {systemText('Admin/Forms/Image/Buttons/Remove')}
										</button>
									</div>
								</div>
							)}
						</div>
					)}
				</div>
				{error && <span className="help-block">{typeof error === 'function' ? error() : error}</span>}
				{warning && <span className="help-block">{typeof warning === 'function' ? warning() : warning}</span>}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		showFormHelp: state.ui.showFormHelp,
	};
};

export default connect(mapStateToProps, null)(ImageEdit);
